import { getEnvironmentVariable } from "../../global/environmentVariables";

import PrivacyBCP from "./privacy/PrivacyBCP";
const AMPLIFY_BRANCH = getEnvironmentVariable("AMPLIFY_BRANCH");

export default function Privacy() {
  if (
    AMPLIFY_BRANCH === "catan-gold" ||
    AMPLIFY_BRANCH === "catan-dev" ||
    AMPLIFY_BRANCH === "catan-prod"
  ) {
    // return <PrivacyCatan />;
  }
  return <PrivacyBCP />;
}
